"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// api fetch settings
var FETCH_TIMEOUT_MS = exports.FETCH_TIMEOUT_MS = 300000;
// general http status codes
var FETCH_STATUS_UNAUTHORIZED = exports.FETCH_STATUS_UNAUTHORIZED = 401;
var FETCH_STATUS_FORBIDDEN = exports.FETCH_STATUS_FORBIDDEN = 403;
var FETCH_STATUS_NOT_FOUND = exports.FETCH_STATUS_NOT_FOUND = 404;
var FETCH_STATUS_UNPROCESSABLE_ENTITY = exports.FETCH_STATUS_UNPROCESSABLE_ENTITY = 422;
// custom status codes
var FETCH_STATUS_TIMEOUT = exports.FETCH_STATUS_TIMEOUT = 999;
var UIDSEP = exports.UIDSEP = "🐙"; // for table field/row uid separation


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants.ts
 ** module id = 222
 ** module chunks = 0
 **/